import { BaseTitle } from "@/components/atom/title/BaseTitle";
import { TitleProps } from "@mantine/core";

export const WorkTitle = ({ ...etcProps }: TitleProps) => {
  return <BaseTitle order={3} fw={700} c={"gray.6"} {...etcProps} />;
};
